import { render, staticRenderFns } from "./RoomBedShow.vue?vue&type=template&id=d1128c8e&scoped=true"
import script from "./RoomBedShow.vue?vue&type=script&lang=js"
export * from "./RoomBedShow.vue?vue&type=script&lang=js"
import style0 from "./RoomBedShow.vue?vue&type=style&index=0&id=d1128c8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1128c8e",
  null
  
)

export default component.exports